import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle,
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getUsers, deleteUser } from '../../../../api/user';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import { ROLES, roleLabel, useAuthUser } from '../../../hooks/useIsAdmin';
import { COLORS, StateBadge } from '../../../components/palette';

function getData(users) {
	return (users || []).map((u) => ({
		id: u._id,
		name: u.fullName,
		email: u.email,
		role: u.role,
		createdAt: u.createdAt,
	}));
}

function roleFormatter(cell) {
	return (
		<StateBadge color={cell === ROLES.ADMIN ? COLORS.blue : COLORS.gray}>
			{roleLabel(cell)}
		</StateBadge>
	);
}

export default function AdminsPage() {
	const [data, setData] = useState([]);
	const [adminId, setAdminId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const me = useAuthUser();
	const myId = me ? String(me._id) : null;

	function buttonFormatter(cell) {
		const isMe = myId && String(cell) === myId;
		return (
			<>
				<Tooltip title='Editar'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-admin/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title={isMe ? 'No puedes eliminar tu propio usuario' : 'Eliminar'}>
					<span>
						<Button
							style={buttonsStyle}
							size='small'
							disabled={!!isMe}
							onClick={() => {
								setAdminId(cell);
								setOpenConfirmDialog(true);
							}}>
							<DeleteIcon />
						</Button>
					</span>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: 'name', text: 'Nombre', sort: true },
		{ dataField: 'email', text: 'Email', sort: true },
		{
			dataField: 'role',
			text: 'Rol',
			formatter: roleFormatter,
			sort: true,
		},
		{
			dataField: 'createdAt',
			text: 'Creado',
			formatter: dateFormatter,
			sort: true,
		},
		{
			dataField: 'id',
			text: '',
			formatter: buttonFormatter,
			searchable: false,
		},
	];

	useEffect(() => {
		getUsers()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: 'No se han podido cargar los usuarios.',
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Administradores y usuarios de solo lectura'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-admin')}>
							Nuevo usuario
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<div className='text-muted font-size-sm mb-4'>
						Los administradores gestionan sesiones y controlan la dinámica. Los
						usuarios de solo lectura (cliente) ven los indicadores y las
						respuestas y descargan los informes.
					</div>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={'¿Seguro que quieres eliminar este usuario?'}
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteUser(adminId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: 'Eliminado',
											customMessage: 'Usuario eliminado correctamente.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'No se ha podido eliminar el usuario.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
